export default () => {
	return '_'+Math.random().toString(36).substring(2);
}